module.exports = __webpack_public_path__ + "static/Dark-Pink-fc6dd20effc8075f67ef1ee4be33ad01.png";